import { Component } from '@angular/core';
import { HttpSpinnerService } from './_httpSpinner.service';

@Component({
  selector: 'app-http-spinner',
  template: `<div *ngIf="httpSpinnerService.showSpinner" class="spinnerContainer">
    <div class="httpSpinner">
      <div class="item item-1">
        <div class="item item-1"></div>
        <div class="item item-2"></div>
        <div class="item item-4"></div>
      </div>
      <div class="item item-2">
        <div class="item item-1"></div>
        <div class="item item-2"></div>
        <div class="item item-3"></div>
      </div>
      <div class="item item-3">
        <div class="item item-2"></div>
        <div class="item item-3"></div>
        <div class="item item-4"></div>
      </div>
      <div class="item item-4">
        <div class="item item-1"></div>
        <div class="item item-3"></div>
        <div class="item item-4"></div>
      </div>
    </div>
  </div>`,
  styleUrls: ['./_httpSpinner.component.css'],
})
export class HttpSpinnerComponent {
  constructor(public httpSpinnerService: HttpSpinnerService) {}
}
